import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { AnimationBuilder, AnimationPlayer, animate, style } from '@angular/animations';

@Component({
  selector: 'app-progress-bar',
  styleUrls: ['./progress-bar.component.scss'],
  templateUrl: './progress-bar.component.html',
  standalone: true,
  imports: [
    MatProgressBarModule
  ]
})
export class ProgressBarComponent implements AfterViewInit {
  @ViewChild('progressBar', { read: ElementRef, static: true }) progressBar!: ElementRef;
  @Input() color: ThemePalette = 'primary';
  @Input() duration!: number;
  @Output() done = new EventEmitter<void>();

  private factory = this.builder.build([
    style({ transform: 'scaleX(1)' }),
    animate('{{duration}}ms linear', style({ transform: 'scaleX(0)' })),
  ]);
  private player!: AnimationPlayer;

  constructor(private builder: AnimationBuilder) {}

  @Input() set paused(e: boolean) {
    if (!this.player) {
      return;
    }
    if (e) {
      this.player.pause();
    } else {
      this.player.play();
    }
  }

  ngAfterViewInit(): void {
    const progressBarElement = this.progressBar.nativeElement as HTMLElement;
    const progressBarInner = Array.from(progressBarElement.children)
      .find((e): e is HTMLElement => (e as HTMLElement).classList.contains('mdc-linear-progress__primary-bar'));

    if (!progressBarInner) {
      return;
    }

    this.player = this.factory.create(progressBarInner, { params: { duration: this.duration } });
    this.player.onDone(() => this.done.emit());
    this.player.play();
  }
}
